import React from 'react'
import { Link } from 'react-router-dom'

export const Buttons = ({ title, width = '150px', handleClick, to, href, type = 'button', disabled = false }) => {
  const className = 'buttons inline-flex min-h-11 items-center justify-center rounded-lg px-4 py-[0.8rem] font-semibold text-black disabled:cursor-not-allowed disabled:opacity-60'
  const style = { width }

  if (to) {
    return <Link to={to} className={className} style={style}>{title}</Link>
  }

  if (href) {
    return <a href={href} className={className} style={style}>{title}</a>
  }

  return (
    <button type={type} onClick={handleClick} disabled={disabled} className={className} style={style}>
      {title}
    </button>
  )
}
